
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DependencyOccurenceInfoItem',
  props: {
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    randomLoadingClassWidth(): string {
      const options = ['w-2/6', 'w-3/6', 'w-4/6']
      return options[Math.floor(Math.random() * options.length)] || 'w-28'
    }
  }
})
